// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__M1j5U","containerBorderless":"styles_containerBorderless__qKG1T","table":"styles_table__eZ3in"};